import React, { useRef, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import ShopByNeedSection from "./components/ShopByNeedSection";
import WhatBringsYouSection from "./components/WhatBringsYouSection";
import CatalogSection from "./components/CatalogSection";
import ContactSection from "./components/ContactSection";
import ProductModal from "./components/ProductModal";
import Footer from "./components/Footer";
import { products } from "./data/products";
import "./App.css";

const HOT_PRODUCT = products.find((p) => p.name === "CGM System") || products[1];

function App() {
  const aboutRef = useRef(null);
  const shopRef = useRef(null);
  const catalogRef = useRef(null);
  const contactRef = useRef(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <div className="app">
      <Navbar />
      <Hero onHotProduct={() => setSelectedProduct(HOT_PRODUCT)} />
      <ShopByNeedSection refProp={shopRef} onViewProduct={setSelectedProduct} />
      <WhatBringsYouSection onViewProduct={setSelectedProduct} />
      <CatalogSection
        refProp={catalogRef}
        initialCategory={null}
        onViewProduct={setSelectedProduct}
      />
      <ContactSection refProp={contactRef} />
      <AboutSection refProp={aboutRef} />
      <Footer />
      <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} />
    </div>
  );
}

export default App;
